// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defaultPropTypes } from '../../containers/dsaView';
import SecurityCorrelations from './SecurityCorrelations';


class Correlations extends Component {

  render() {
    const {
      categories,
      baseNavRoute,
      completedCategoriesCount,
      onAnswerCorrelation,
      onBatchAnswerCorrelations,
      essentialCorrelations,
      allCorrelations,
      answeredCorrelations,
      area,
      activeAreaIds,
      areas,
      abilities
    } = this.props;

    return (
      <div className='correlations'>
        <SecurityCorrelations
          baseNavRoute={baseNavRoute}
          abilities={abilities}
          categories={categories}
          completedCategoriesCount={completedCategoriesCount}
          onAnswer={onAnswerCorrelation}
          onBatchAnswerCorrelations={onBatchAnswerCorrelations}
          essentialCorrelations={essentialCorrelations}
          allCorrelations={allCorrelations}
          answeredCorrelations={answeredCorrelations}
          area={area}
          activeAreaIds={activeAreaIds}
          areas={areas}
        />
      </div>
    );
  }
}

Correlations.propTypes = {
  ...defaultPropTypes,
  categories: PropTypes.array.isRequired,
  completedCategoriesCount: PropTypes.number.isRequired,
  onAnswerCorrelation: PropTypes.func.isRequired,
  onBatchAnswerCorrelations: PropTypes.func.isRequired,
  essentialCorrelations: PropTypes.array.isRequired,
  allCorrelations: PropTypes.array.isRequired
};

export default Correlations;



// WEBPACK FOOTER //
// ./src/components/correlations/Correlations.js